import { clipParams, clipParamTime, prevNextKeyframeTimes } from '../../format/params';
import { usePlayback } from '../../state/playback';
import { findClip, useTimeline } from '../../state/timeline';
import { keyframeTimelineTime } from './ParamSlider';

/** Seek to the selected clip's previous/next keyframe (any parameter). */
export function jumpToKeyframe(seek: (t: number) => void, dir: 1 | -1): void {
  const s = useTimeline.getState();
  if (s.selection.length !== 1) return;
  const loc = findClip(s.edit, s.selection[0]);
  if (!loc) return;
  const params = clipParams(loc.clip);
  const axisT = clipParamTime(loc.clip, usePlayback.getState().currentTime);
  const { prev, next } = prevNextKeyframeTimes(params, axisT);
  const target = dir < 0 ? prev : next;
  if (target !== null) seek(keyframeTimelineTime(loc.clip, target));
}
